import { amountReadBack, parseTypedAmount } from "../../utils/typedAmount";

/**
 * G-126 (OD-154) — under a money box, what the app read ("= €1800.00"), or why
 * it refuses the text, so a misread shows before Save. Renders nothing while
 * the box is empty.
 */
export function AmountReadBack({ raw }: { raw: string }) {
  const text = amountReadBack(raw);
  if (text === null) return null;
  const refused = !parseTypedAmount(raw).ok;
  return (
    <small className={`hint finances-amount-readback${refused ? " is-refused" : ""}`} aria-live="polite">
      {text}
    </small>
  );
}
